export default {
  // TODO: use normalizr
  SET_OPCIONES_CATEGORIES(state, payload) {
    state.herramientas.mantenedores.categorias = (payload.opciones || [])
      .reduce((index, option) => {
        const extraOption = JSON.parse(option.extra);
        return {
          ...index,
          [option.opcionId]: {
            ...option,
            extra: {
              numInt: extraOption.numInt || false,
              numOf: extraOption.numOf || false,
              uso: extraOption.uso || {}
            }
          }
        };
      }, {});
  },
  // TODO: use normalizr
  SET_OPCIONES_DOCUMENTOS(state, payload) {
    state.herramientas.mantenedores.documentos = (payload.opciones || [])
      .reduce((index, option) => {
        const extraOption = JSON.parse(option.extra);
        return {
          ...index,
          [option.opcionId]: {
            ...option,
            extra: {
              ...(extraOption.idDocDigital && { idDocDigital: extraOption.idDocDigital }),
              numInt: extraOption.numInt || false,
              numOf: extraOption.numOf || false,
              uso: extraOption.uso || {}
            }
          }
        };
      }, {});
  },
  SET_OPCIONES_CATEGORIES_INSTITUTIONS(state, payload) {
    state.herramientas.mantenedores.categoryInstitutions = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  // TODO: use normalizr
  SET_OPCIONES_INSTITUTIONS(state, payload) {
    state.herramientas.mantenedores.institutions = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_OPCIONES_CATEGORIES_SUBJECTS(state, payload) {
    state.herramientas.mantenedores.categorySubjects = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_OPCIONES_CATEGORIES_SERVICES(state, payload) {
    state.herramientas.mantenedores.categoryServices = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_OPCIONES_CATEGORIES_REGIONS(state, payload) {
    state.herramientas.mantenedores.categoryRegions = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_OPCIONES_SUBJECTS(state, payload) {
    state.herramientas.mantenedores.subjects = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_OPCIONES_SERVICES(state, payload) {
    state.herramientas.mantenedores.services = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_OPCIONES_REGIONS(state, payload) {
    state.herramientas.mantenedores.regions = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_OPCIONES_CATEGORIES_ACTIVITIES(state, payload) {
    state.herramientas.mantenedores.categoryActivities = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_OPCIONES_CATEGORIES_STATES(state, payload) {
    state.herramientas.mantenedores.categoryStates = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_OPCIONES_CATEGORIES_TYPE_ATTACHMENTS(state, payload) {
    state.herramientas.mantenedores.categoryTypeAttachments = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_OPCIONES_CATEGORIES_RETENTION_PERCENTAGE(state, payload) {
    state.herramientas.mantenedores.categoryRetentionPercentage = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_OPCIONES_STATES(state, payload) {
    state.herramientas.mantenedores.subStateStates = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_OPCIONES_ACTIVITIES(state, payload) {
    state.herramientas.mantenedores.activityStates = (payload.opciones || [])
      .reduce((index, option) => ({
        ...index,
        [option.opcionId]: option
      }), {});
  },
  SET_CATEGORY(state, payload) {
    state.category = payload;
  },
  SET_SUBJECT(state, payload) {
    state.subject = payload;
  },
  SET_SERVICE(state, payload) {
    state.service = payload;
  },
  SET_REGION(state, payload) {
    state.region = payload;
  },
  SET_INSTITUTION(state, payload) {
    state.institution = payload;
  },
  SET_ACTIVITY(state, payload) {
    state.activity = payload;
  },
  SET_STATE(state, payload) {
    state.kanbanState = payload;
  },
  SET_TYPE_ATTACHMENT(state, payload) {
    state.typeAttachment = payload;
  },
  UPDATE_OPTION_CATEGORY(state, option) {
    state.herramientas.mantenedores.categorias[option.opcionId] = option;
  },
  UPDATE_OPTION_DOCUMENT(state, option) {
    state.herramientas.mantenedores.documentos[option.opcionId] = option;
  },
  UPDATE_OPTION_INSTITUTION_CATEGORY(state, { option }) {
    state.herramientas.mantenedores.categoryInstitutions[option.opcionId] = option;
  },
  UPDATE_OPTION_INSTITUTION(state, { option }) {
    state.herramientas.mantenedores.institutions[option.opcionId] = option;
  },
  UPDATE_OPTION_SUBJECT_CATEGORY(state, { option }) {
    state.herramientas.mantenedores.categorySubjects[option.opcionId] = option;
  },
  UPDATE_OPTION_SUBJECT(state, { option }) {
    state.herramientas.mantenedores.subjects[option.opcionId] = option;
  },
  UPDATE_OPTION_SERVICE_CATEGORY(state, { option }) {
    state.herramientas.mantenedores.categoryServices[option.opcionId] = option;
  },
  UPDATE_OPTION_SERVICE(state, { option }) {
    state.herramientas.mantenedores.services[option.opcionId] = option;
  },
  UPDATE_OPTION_REGION_CATEGORY(state, { option }) {
    state.herramientas.mantenedores.categoryRegions[option.opcionId] = option;
  },
  UPDATE_OPTION_REGION(state, { option }) {
    state.herramientas.mantenedores.regions[option.opcionId] = option;
  },
  UPDATE_OPTION_ACTIVITY_CATEGORY(state, { option }) {
    state.herramientas.mantenedores.categoryActivities[option.opcionId] = option;
  },
  UPDATE_OPTION_ACTIVITY(state, { option }) {
    state.herramientas.mantenedores.activityStates[option.opcionId] = option;
  },
  UPDATE_OPTION_STATE_CATEGORY(state, { option }) {
    state.herramientas.mantenedores.categoryStates[option.opcionId] = option;
  },
  UPDATE_OPTION_TYPE_ATTACHMENT_CATEGORY(state, { option }) {
    state.herramientas.mantenedores.categoryTypeAttachments[option.opcionId] = option;
  },
  UPDATE_OPTION_STATE(state, { option }) {
    state.herramientas.mantenedores.subStateStates[option.opcionId] = option;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_SUCCESS_MESSAGE(state, payload) {
    state.successAccion = payload;
  },
  SET_ERROR_MESSAGE(state, payload) {
    state.error = payload;
  }
};
